import { useContext } from "react";
import { DeliveryFoodContext } from "../../../../DeliveryFoodContext";
import { DeliveryFoodItemRestaurantCell } from "../../../../types/DeliveryFoodTypes";
import DeliveryFoodCell from "../../DeliveryFoodCell";

export const DeliveryFoodItemRestaurantSalesMultipleCell = ({
    config,
}: {
    config: DeliveryFoodItemRestaurantCell;
}) => {
    const { deliveryFoodState } = useContext(DeliveryFoodContext);
    const { ingredient, restaurant, restaurantId, index } = config;

    if (deliveryFoodState.mode.display.RST[restaurantId].sales.MULTIPLE === false) {
        return null;
    }

    const key = `sales-multiple-cell-${index}`;
    const summary = ingredient.results.RST?.[restaurantId].sales?.MULTIPLE;

    if (!summary) {
        return null;
    }

    return (
        <DeliveryFoodCell
            key={key}
            fieldName={"sales"}
            styleName={"MULTIPLE"}
            salesType={"MULTIPLE"}
            summary={summary}
            index={index}
            ingredient={ingredient}
            restaurant={restaurant}
        />
    );
};
